// extracted by mini-css-extract-plugin
export default {"formGroup":"_-_-record-it-components-src-form-FormGroup-__formGroup"};